import { prefixObjectValues as pre } from '../utils';

const prefix = 'insurance-table';

const table = pre(
  {
    row: 'row-',
    sortCompany: 'sort-company-btn',
    sortPolicyNumber: 'sort-policy-num-btn',
    sortPeriod: 'sort-period-btn',
    sortStatus: 'sort-status-btn',
    insuranceCompany: 'insurance-company-',
    policyNumber: 'insurance-policy-num-',
    coveragePeriod: 'insurance-coverage-period-',
    coverageRow: 'insurance-coverage-row-',
    coverageStatus: 'insurance-status-',
    editBtn: 'edit-btn-',
    deleteBtn: 'delete-btn-',
    addBtn: 'add-btn-',
    emptyState: 'empty-state',
  },
  prefix
);

export default {
  ...table,
};
